import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { GET_MANAGERS, GET_WORKERS, GET_WORKERSPROFILE, GET_MT_SERVICE } from './endpoints';

@Injectable({
  providedIn: 'root'
})
export class CommonService extends BaseService{

  constructor(http: HttpClient) { 
    super(http);
  }

  saveManager(data: any): any{
    const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
    };
    return this.postRequest(GET_MANAGERS, data, options);
  }
  saveWorker(data:any):any{
    const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
    };
    return this.postRequest(GET_WORKERS, data, options)
  }
  updateMytaletRate(data){
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*'
      }
    };
    return this.postRequest(GET_MT_SERVICE, data, options);
  }
  getMytalentServices(){
    const url = GET_MT_SERVICE;
    return this.getRequest(url, null);
  }
  getMytalentCandiates(id){
    const url = GET_MT_SERVICE+"/GetCandidatesByService?serviceTypeId="+id;
    return this.getRequest(url, null);
  }

  getMytalentAssignments(id, candidate){
    const url = GET_MT_SERVICE+"/GetAssignmentsByServiceAndCandidate?serviceTypeId="+id+"&candidateId="+candidate;
    return this.getRequest(url, null);
  }
  GetAssignmentDetailById(id){
    const url = GET_MT_SERVICE + "/GetAssignmentDetailById?assignmentId=" + id;
    return this.getRequest(url, null);
  }
  GetSearchSummary(){
    const url = GET_MT_SERVICE+"/GetSearchSummary";
    return this.getRequest(url, null);
  }
  GetCandidatesRatingInfo(data){
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*'
      }
    };
    return this.postRequest(GET_MT_SERVICE + '/GetCandidatesRatingInfo', data, options);
  }
  GetCandidatesAssignmentsInfo(data){
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*'
      }
    };
    return this.postRequest(GET_MT_SERVICE + '/GetCandidatesAssignmentsInfo', data, options);
  }
  DeleteWorkerProfile(data){
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*'
      }
    };
    return this.postRequest(GET_MT_SERVICE + '/DeleteWorkerProfile', data, options);
  }
  getWorkerProfile(){
    const url = GET_WORKERSPROFILE;
    return this.getRequest(url, null);
  }

}
